module.exports = __webpack_public_path__ + "no_setup_tax.png?7ed5afa5e7ab82fe2ada95827e54f45a";